export const COLOR_WHITE = { key: 'White', rgb: [255, 255, 255] };
export const COLOR_BLACK = { key: 'Black', rgb: [0, 0, 0] };
export const COLOR_BLUE = { key: 'Blue', rgb: [12, 202, 248] };
export const COLOR_GREEN = { key: 'Green', rgb: [14, 216, 63] };
export const COLOR_YELLOW = { key: 'Yellow', rgb: [233, 243, 0] };
export const COLOR_ORANGE = { key: 'Orange', rgb: [255, 181, 0] };
export const COLOR_PINK = { key: 'Pink', rgb: [254, 27, 135] };
export const COLOR_RED = { key: 'Red', rgb: [255, 45, 20] };
export const COLOR_PURPLE = { key: 'Purple', rgb: [203, 36, 211] };

export const COLOR_TOOLBAR = [
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_BLUE,
  COLOR_GREEN,
  COLOR_YELLOW,
  COLOR_ORANGE,
  COLOR_PINK,
  COLOR_RED,
  COLOR_PURPLE,
];
